import React, { useState, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { CFOP_OPTIONS } from './SelectCFOP';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isInvalid?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  placeholder?: string;
  size?: 'sm' | 'lg';
  onBlur?: () => void;
  name?: string;
}

const NaturezaOperacaoInput = React.forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, onBlur, disabled, isInvalid, autoFocus, maxLength = 60, placeholder, size, name }, ref) => {
    const [open, setOpen] = useState(false);
    const [suggestions, setSuggestions] = useState<typeof CFOP_OPTIONS>([]);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const v = e.target.value;
      onChange(v);
      if (v.trim().length > 0) {
        const lower = v.toLowerCase();
        const filtered = CFOP_OPTIONS.filter(
          o => o.value.startsWith(v) || o.label.toLowerCase().includes(lower)
        ).slice(0, 12);
        setSuggestions(filtered);
        setOpen(filtered.length > 0);
      } else {
        setOpen(false);
      }
    };

    const handleSelect = (label: string) => {
      onChange(label.slice(0, maxLength));
      setOpen(false);
    };

    useEffect(() => {
      const handler = (e: MouseEvent) => {
        if (!containerRef.current?.contains(e.target as Node)) setOpen(false);
      };
      document.addEventListener('mousedown', handler);
      return () => document.removeEventListener('mousedown', handler);
    }, []);

    return (
      <div ref={containerRef} style={{ position: 'relative' }}>
        <Form.Control
          ref={ref}
          name={name}
          size={size}
          type="text"
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
          isInvalid={isInvalid}
          maxLength={maxLength}
          placeholder={placeholder}
          autoFocus={autoFocus}
          autoComplete="off"
        />
        {open && (
          <div className="nfe-natureza-suggestions">
            {suggestions.map(o => (
              <div
                key={o.value}
                className="nfe-natureza-suggestion-item"
                onMouseDown={() => handleSelect(o.label)}
              >
                <span className="nfe-natureza-cfop-code">{o.value}</span>
                <span className="nfe-natureza-cfop-label">{o.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
);

NaturezaOperacaoInput.displayName = 'NaturezaOperacaoInput';

export default NaturezaOperacaoInput;
